module.exports = __webpack_public_path__ + "img/moon-6.3e7c07e0.svg";